import { render } from "./ParticipantsModal.vue?vue&type=template&id=b85b9f6e"
import script from "./ParticipantsModal.vue?vue&type=script&lang=js"
export * from "./ParticipantsModal.vue?vue&type=script&lang=js"

import "./ParticipantsModal.vue?vue&type=style&index=0&id=b85b9f6e&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__